import apiRequest from './handler';

const SupportChatService = {
    sendMessage: async (data, setIsAuthenticated, navigate, isNewApi=false) => {
        try {
            const response = apiRequest(
                `/support/send_message`,
                'post',
                data,
                true,
                setIsAuthenticated,
                navigate,
                isNewApi
            );
            return response;
        } catch (error) {
            console.error('Error fetching enquiry options:', error);
            throw error;
        }
    },

    sendTemplate: async (data, setIsAuthenticated, navigate, isNewApi=false) => {
        console.log(isNewApi);
        try {
            const response = apiRequest(
                `/support/send_template`,
                'post',
                data,
                true,
                setIsAuthenticated,
                navigate,
                false,
                isNewApi
            );
            return response;
        } catch (error) {
            console.error('Error fetching enquiry options:', error);
            throw error;
        }
    },

    sendSupportMessage: async (data, setIsAuthenticated, navigate, isNewApi=false) => {
        console.log('isNewApi: ', isNewApi);
        try {
            const response = apiRequest(
                `/support/send_message`,
                'post',
                data,
                true,
                setIsAuthenticated,
                navigate,
                false,
                isNewApi
            );
            return response;
        } catch (error) {
            console.error('Error fetching enquiry options:', error);
            throw error;
        }
    },
    fetchActiveChats: async ({ status = 'active', lastId = null }, setIsAuthenticated, navigate) => {
        let url = `/support/active-chats?status=${status}`;
        if (lastId) url += `&last_id=${lastId}`;
        try {
            const response = await apiRequest(
                url,
                'GET',
                null,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching active chats:', error);
            throw error;
        }
    },
    markChatAsRead: async (chatId, setIsAuthenticated, navigate) => {
        try {
            return await apiRequest(
                `/support/mark-chat-as-read`,
                'POST',
                { chat_id: chatId },
                true,
                setIsAuthenticated,
                navigate
            );
        } catch (error) {
            console.error('Error marking chat as read:', error);
            throw error;
        }
    }
};

export default SupportChatService;
